import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import get from "lodash/get";
import React from "react";
import Helmet from 'react-helmet';
import headersList from 'Constants/headersList';
import { connect } from "react-redux";
import { instance } from "../../../../../../Actions/AxiosInstance";
import DynamicForm from "../../../../../../Component/DynamicForm";
import { radioinputconverter } from "../../../../../../Component/DynamicForm/Fields/Radio";
import InputValues from '../../../../../../Component/InputValues';
import FloatValues from '../../../../../../Component/FloatValues';
import { selectinputconverter } from "../../../../../../Component/DynamicForm/Fields/Select";
import { ErrorMessages } from "../../../../../../Constants";
import daysList from "../../../../../../Constants/DATA/daysList";

const POST_DATA = {
  "isloanfacility": false,
  "isafterprobation": true,
  "eligibledays": null,
  "iseligibleinnotice": false,
  "eligiblpackage": null,
  "maxlimittypeid": null,
  "maxlimitvalue": null,
  "maxlimitvalue1": null,
  "maxinstallments": 1,
  "interestrate": 12,
  "interestcaltypeid": 1,
};
export class LoanSettings extends React.Component {
  state = {
    postdata: POST_DATA,
  };

  componentDidMount() {
    this.getdata();
  }

  getdata = () => {
    instance
      .get("payroll/getloanconfigbysubid")
      .then((resp) => {
        const data = get(resp, "data.result[0]", POST_DATA);
        if (data.maxlimittypeid == 1) {
          data.maxlimitvalue1 = null;
          data.maxlimitvalue = data.maxlimitvalue;
        } else {
          data.maxlimitvalue1 = data.maxlimitvalue;
          data.maxlimitvalue = null;
        }
        this.setState({
          postdata: get(resp, "data.result[0]", POST_DATA),
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: "error" });
      });
  };

  submit = () => {
    const { postdata } = this.state;
    const { isloanfacility, eligibledays, isafterprobation, maxlimittypeid, maxlimitvalue, maxlimitvalue1, interestrate, eligiblpackage } = postdata;
    if (isloanfacility) {
      if (!isafterprobation && !eligibledays) {
        this.props.enqueueSnackbar("Please select eligible days", { variant: "error" });
        return;
      } else if (eligiblpackage == null) {
        this.props.enqueueSnackbar("Please enter eligible package", { variant: "error" });
        return;
      } else if (!maxlimittypeid) {
        this.props.enqueueSnackbar("Please select maximum loan amount limit", { variant: "error" });
        return;
      } else if (maxlimittypeid == 1 && !maxlimitvalue) {
        this.props.enqueueSnackbar("Please enter value", { variant: "error" });
        return;
      } else if (maxlimittypeid == 2 && !maxlimitvalue1) {
        this.props.enqueueSnackbar("Please enter value", { variant: "error" });
        return;
      } else if (interestrate == null) {
        this.props.enqueueSnackbar("Please enter interest rate", { variant: "error" });
        return;
      } else {
        postdata.maxlimitvalue = postdata.maxlimittypeid == 2 ? postdata.maxlimitvalue1 : postdata.maxlimitvalue;
        delete postdata.maxlimitvalue1;
        instance
        .post("payroll/createloannconfig", postdata)
        .then(() => {
          this.props.enqueueSnackbar(ErrorMessages.E0000, { variant: "success" });
          this.getdata();
        })
        .catch((error) => {
          this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: "error" });
        });
      }
    } else {
      postdata.maxlimitvalue = postdata.maxlimittypeid == 2 ? postdata.maxlimitvalue1 : postdata.maxlimitvalue;
      delete postdata.maxlimitvalue1;
      instance
      .post("payroll/createloannconfig", postdata)
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0000, { variant: "success" });
        this.getdata();
      })
      .catch((error) => {
        this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: "error" });
      });
    }
  };

  render() {
    const { postdata } = this.state;
    return (
      <div>
        <Helmet>
          <title>{headersList.Config.Misc.LoanSettings.header}</title>
        </Helmet>
        <Grid container>
          <Grid md={12} xs={12} lg={12} sm={12}>
             <div>
              <div className="margin-bottom-20">
                <div className="t-16">
                  <Switch
                    checked={postdata.isloanfacility ? true : false}
                    onChange={(val) => this.setState({ postdata: { ...POST_DATA,
                    isloanfacility: val.target.checked,
                    "isafterprobation": true,
                    "eligibledays": null,
                    "iseligibleinnotice": false,
                    "eligiblpackage": null,
                    "maxlimittypeid": null,
                    "maxlimitvalue": null,
                    "maxlimitvalue1": null,
                    "maxinstallments": 1,
                    "interestrate": 12,
                    "interestcaltypeid": 1 } })}
                    disabled= {this.props.permissions && !this.props.permissions.editable}
                    value={postdata.isfbp ? true : false} color="primary" />
                    Offer loan facility to employees
                </div>
              </div>
              {postdata.isloanfacility
              && <div>
                <div className="margin-bottom-32 padding16 width50" style={{ background: "#f7f8f8" }}>
                  <div className="large-dark-secondary margin-bottom-8">When are employees eligible to avail loans?</div>
                    <DynamicForm
                      fields={radioinputconverter({
                        value: postdata.isafterprobation,
                        label: "Upon probation confirmation",
                        labelclass: "small-dark-secondary margin-top-2",
                        disabled: this.props.permissions && !this.props.permissions.editable,
                      })}
                      onChange={() => this.setState({ postdata: { ...postdata, isafterprobation: true, eligibledays: null } })}
                    />

                    <span style={{ width: 27, float: "left", marginTop: 16 }}>
                      <DynamicForm
                      fields={radioinputconverter({
                        value: !postdata.isafterprobation,
                        label: "",
                        labelclass: "small-dark-secondary  margin-top-2",
                        disabled: this.props.permissions && !this.props.permissions.editable,
                      })}
                      onChange={() => this.setState({ postdata: { ...postdata, isafterprobation: false, eligibledays: 10 } })}
                    />
                    </span>
                    <span>
                      <InputValues
                        field="eligibledays"
                        defaultvalue={postdata.eligibledays}
                        min={postdata.isafterprobation ? "" : 1}
                        max={365}
                        disabled={(this.props.permissions && !this.props.permissions.editable) || postdata.isafterprobation}
                        value={postdata.eligibledays}
                        onChange={(e, field, max) => this.setState({ postdata: { ...postdata, eligibledays: parseInt(e.target.value) } })}
                      />
                    </span>
                    <span>days after joining date</span>
                </div>
                <div className="margin-bottom-32 padding16 width50" style={{ background: "#f7f8f8", minHeight: 50 }}>
                  <div className="large-dark-secondary">Allow Employees serving notice period to avail loans?</div>
                  <div>
                    <span className="floatleft width50">
                      <DynamicForm
                        className="width100"
                        fields={radioinputconverter({
                          value: postdata.iseligibleinnotice,
                          label: "Yes",
                          disabled: this.props.permissions && !this.props.permissions.editable,
                        })}
                        onChange={() => this.setState({ postdata: { ...postdata, iseligibleinnotice: true } })}
                      />
                    </span>
                    <span className="floatleft width50">
                      <DynamicForm
                        className="width100"
                        fields={radioinputconverter({
                          value: !postdata.iseligibleinnotice,
                          label: "No",
                          disabled: this.props.permissions && !this.props.permissions.editable,
                        })}
                        onChange={() => this.setState({ postdata: { ...postdata, iseligibleinnotice: false } })}
                      />
                    </span>
                  </div>
                </div>
                <div className="margin-bottom-32">
                  <div className="t-14">Employees are eligible to avail loan if their annual/monthly package is greater than
                    <InputValues
                      field="eligiblpackage"
                      defaultvalue={''}
                      min={0}
                      max={100000000}
                      value={postdata.eligiblpackage}
                      disabled={this.props.permissions && !this.props.permissions.editable}
                      onChange={(e, field, max) => {
                          console.log("ee", e.target.value);
                          this.setState({ postdata: { ...postdata, eligiblpackage: parseInt(e.target.value) } });
                      }}
                    />
                  </div>
                </div>
                <div className="margin-bottom-32 padding16 width50" style={{ background: "#f7f8f8" }}>
                  <div className="large-dark-secondary margin-bottom-8">Maximum loan amount will be limited to one of the following conditions</div>
                  <div>
                    <span style={{ widht: 50, marginTop: 16, float: "left" }}>
                      <DynamicForm
                        fields={radioinputconverter({
                          value: postdata.maxlimittypeid == 1,
                          label: "",
                          labelclass: "small-dark-secondary margin-top-2",
                          disabled: this.props.permissions && !this.props.permissions.editable,
                        })}
                        onChange={() => this.setState({ postdata: { ...postdata, isafterprobation: true, eligibledays: null, maxlimittypeid: 1, maxlimitvalue1: null } })}
                      />
                    </span>
                    <span>
                      <InputValues
                        field="maxlimitvalue"
                        defaultvalue={1}
                        disabled={(this.props.permissions && !this.props.permissions.editable) || !postdata.maxlimittypeid || postdata.maxlimittypeid == 2}
                        min={0}
                        max={100}
                        value={postdata.maxlimitvalue}
                        onChange={(e, field, max) => this.setState({ postdata: { ...postdata, maxlimitvalue: parseInt(e.target.value) } })}
                      />
                    </span>
                    <span> % Of employee's annual package</span>
                  </div>
                  <div>
                    <span style={{ widht: 50, marginTop: 16, float: "left" }}>
                      <DynamicForm
                        fields={radioinputconverter({
                          value: postdata.maxlimittypeid == 2,
                          label: "",
                          labelclass: "small-dark-secondary margin-top-2",
                          disabled: this.props.permissions && !this.props.permissions.editable,
                        })}
                        onChange={() => this.setState({ postdata: { ...postdata, isafterprobation: true, eligibledays: null, maxlimittypeid: 2, maxlimitvalue: null } })}
                      />
                    </span>
                    <span>
                      <InputValues
                        field="maxlimitvalue1"
                        defaultvalue={1}
                        min={0}
                        disabled={(this.props.permissions && !this.props.permissions.editable) || !postdata.maxlimittypeid || postdata.maxlimittypeid == 1}
                        max={100000000}
                        value={postdata.maxlimitvalue1}
                        onChange={(e, field, max) => this.setState({ postdata: { ...postdata, maxlimitvalue1: parseInt(e.target.value) } })}
                      />
                    </span>
                    <span> Fixed Amount</span>
                  </div>
                </div>
                <div className='t-14'>
                  Maximum number of loan installments proccessed in the company is
                  <InputValues
                    field="maxinstallments"
                    defaultvalue={1}
                    min={1}
                    max={36}
                    disabled={this.props.permissions && !this.props.permissions.editable}
                    value={postdata.maxinstallments}
                    onChange={(e, field, max) => this.setState({ postdata: { ...postdata, maxinstallments: e ? parseInt(e.target.value) : "" } })}
                  />
                </div>
                <div className='t-14 margin-bottom-16'>
                  Default interest rate in the company
                  <FloatValues
                    field="interestrate"
                    defaultvalue={""}
                    min={0}
                    max={100}
                    disabled={this.props.permissions && !this.props.permissions.editable}
                    value={postdata.interestrate}
                    onChange={(e, field, max) => this.setState({ postdata: { ...postdata, interestrate: e.target.value ? e.target.value : "" } })}
                  />
                </div>
                <div className="margin-bottom-32 padding16 width50" style={{ background: "#f7f8f8", minHeight: 50 }}>
                  <div className="large-dark-secondary margin-bottom-16">Method for calculating interest</div>
                  <div>
                      <DynamicForm
                        className="width100"
                        fields={radioinputconverter({
                          value: postdata.interestcaltypeid == 1,
                          label: "Reducing interest rate",
                          disabled: this.props.permissions && !this.props.permissions.editable,
                        })}
                        onChange={() => this.setState({ postdata: { ...postdata, interestcaltypeid: 1 } })}
                      />
                  </div>
                  <div>
                      <DynamicForm
                        className="width100 t-16"
                        fields={radioinputconverter({
                          value: postdata.interestcaltypeid == 2,
                          label: "Flat interest rate",
                          disabled: this.props.permissions && !this.props.permissions.editable,
                        })}
                        onChange={() => this.setState({ postdata: { ...postdata, interestcaltypeid: 2 } })}
                      />
                  </div>
                </div>
              </div>}
              {this.props.permissions && this.props.permissions.editable &&
              <Grid container>
              <Grid item xs={12} md={6} sm={12} style={{ justifyContent: "flex-start", display: "flex" }}>
                <div className="">
                  <Button className="btn btn-secondary-md-blue margin-right-8" variant="contained" onClick={this.submit}>
                    Save
                  </Button>
                </div>
              </Grid>
            </Grid>
              }
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(LoanSettings);
